const sentryDsn = process.env.SENTRY_DSN!;
const sentryEnvironment = process.env.SENTRY_ENVIRONMENT!;
const sentryRelease = process.env.SENTRY_RELEASE || null;
const segmentWriteKey = process.env.SEGMENT_WRITE_KEY;

export { sentryDsn, sentryEnvironment, sentryRelease, segmentWriteKey };
